module.exports = __webpack_public_path__ + "static/media/add.d1b8e84e.svg";